import { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & {
  diameter?: number;
  ratio?: number;
};

const defaultDiameter = 60;

export default forwardRef<SVGSVGElement, OwnProps>(
  ({ diameter = defaultDiameter, ratio = 1, ...props }, ref) => {
    const circumference = Math.PI * diameter;
    const countDownLength = ratio * circumference;
    const remaining = circumference - countDownLength;

    return (
      <svg
        width="66"
        height="66"
        viewBox="0 0 66 66"
        fill="none"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          id="Background"
          d="M63 33C63 36.9397 62.224 40.8407 60.7164 44.4805C59.2087 48.1203 56.999 51.4274 54.2132 54.2132C51.4274 56.999 48.1203 59.2087 44.4805 60.7164C40.8407 62.224 36.9397 63 33 63C29.0603 63 25.1593 62.224 21.5195 60.7164C17.8797 59.2087 14.5726 56.9989 11.7868 54.2132C9.00104 51.4274 6.79126 48.1202 5.28362 44.4805C3.77598 40.8407 3.00001 36.9396 3.00001 33C3.00001 29.0603 3.77598 25.1592 5.28363 21.5195C6.79127 17.8797 9.00105 14.5725 11.7868 11.7868C14.5726 9.00102 17.8797 6.79124 21.5195 5.2836C25.1593 3.77596 29.0604 2.99999 33 2.99999C36.9397 3 40.8408 3.77597 44.4805 5.28362C48.1203 6.79126 51.4275 9.00105 54.2132 11.7868C56.999 14.5726 59.2088 17.8797 60.7164 21.5195C62.224 25.1593 63 29.0604 63 33L63 33Z"
          stroke="#E2E8F0"
          strokeWidth="4.5"
        />
        <path
          id="Front"
          d="M33 3.00002C36.9397 3.00002 40.8407 3.77599 44.4805 5.28363C48.1203 6.79127 51.4274 9.00105 54.2132 11.7868C56.999 14.5726 59.2087 17.8797 60.7164 21.5195C62.224 25.1593 63 29.0604 63 33C63 36.9397 62.224 40.8408 60.7164 44.4805C59.2087 48.1203 56.9989 51.4275 54.2132 54.2132C51.4274 56.999 48.1203 59.2088 44.4805 60.7164C40.8407 62.224 36.9396 63 33 63C29.0603 63 25.1593 62.224 21.5195 60.7164C17.8797 59.2087 14.5725 56.999 11.7868 54.2132C9.00103 51.4274 6.79125 48.1203 5.28361 44.4805C3.77597 40.8407 3 36.9397 3 33C3 29.0603 3.77598 25.1593 5.28362 21.5195C6.79126 17.8797 9.00105 14.5726 11.7868 11.7868C14.5726 9.00104 17.8797 6.79126 21.5195 5.28362C25.1593 3.77598 29.0604 3.00001 33 3.00002L33 3.00002Z"
          stroke={countDownLength ? '#0F9654' : '#E2E8F0'}
          strokeWidth="3.75"
          strokeLinecap="round"
          strokeDasharray={`${countDownLength} ${remaining}`}
          strokeDashoffset={countDownLength}
        />
      </svg>
    );
  }
);
